import { EmbryoSelection } from './types';

const SELECTION_KEY = 'freeze_embryo_selection';

export const SelectionService = {
  getSelection(): EmbryoSelection {
    const stored = localStorage.getItem(SELECTION_KEY);
    return stored
      ? JSON.parse(stored)
      : {
          liveEmbryoIds: [],
          tempEmbryoIds: [],
          fertilizationIds: [],
          lastUpdated: Date.now(),
        };
  },

  setSelection(selection: EmbryoSelection) {
    localStorage.setItem(
      SELECTION_KEY,
      JSON.stringify({
        ...selection,
        lastUpdated: Date.now(),
      }),
    );
  },

  updateSelection(type: 'live' | 'temp' | 'fert', ids: string[]) {
    const current = this.getSelection();
    const updated = {
      ...current,
      [type === 'live'
        ? 'liveEmbryoIds'
        : type === 'temp'
          ? 'tempEmbryoIds'
          : 'fertilizationIds']: ids,
      lastUpdated: Date.now(),
    };
    this.setSelection(updated);
    return updated;
  },
};
